import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import type { PaymentProcessingMethod } from '../model/types';

interface UpdatePaymentsSettingsParams {
  paymentProcessingMethod?: PaymentProcessingMethod;
  prorationMode?: string;
  prorationEnabled?: boolean;
  prorationBasis?: 'calendar' | 'session';
  failedPaymentRetryCount?: number;
  consecutiveAbsencesThreshold?: number;
  collectPaymentMethod?: boolean;
  requirePaymentMethodForPaidEnrollments?: boolean;
  retainPaymentMethodWhileEnrolled?: boolean;
  timezone?: string;
  paymentRunPostponeCronEnabled?: boolean;
  /** Manual-only (ENR-3918): promote Upcoming → Invoice Scheduled without auto-charge. */
  postTuitionToParentAccount?: boolean;
  combineHourlyMinutesForBestRate?: boolean;
  combineHourlyMinutesAcrossSiblings?: boolean;
  consistentMonthlyHourlyTuition?: boolean;
  familyClassCountTuitionEnabled?: boolean;
  defaultClassCountTuitionBillingId?: string | null;
  allowSelectiveInvoicePayment?: boolean;
  allowPartialInvoicePayment?: boolean;
}

export const updatePaymentsSettings = async (
  params: UpdatePaymentsSettingsParams,
) => {
  const response = await baseAPI.put<unknown>(
    '/studios/payment-settings',
    params,
  );
  return response.data;
};

export const useUpdatePaymentsSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePaymentsSettings,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.STUDIO_DETAILS] });
    },
    // onError: (error: any) => {},
  });
};
